module.exports = __webpack_public_path__ + "img/e_1_4_g.91c10736.png";